export default {
  ETaskTypes: {
    Task: -1,
    Review: 0,
    Notification: 1,
    Decision: 2,
    Approve: 3,
    ApproveWithSignature: 4,
    Training: 5,
    Distribution: 6,
    Analysis: 7,
    Start: 8,
    End: 9,
    ReleaseDocument: 10,
    Properties: 11,
  },
};
